import * as _ from 'lodash';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { faPlay, IconDefinition } from "@fortawesome/free-solid-svg-icons";

import { BaseComponent } from '../base.component';
import { Game } from '../core-services/games/games.model';
import { GamesStore } from '../core-services/games/games.store';
import { UserStore } from '../core-services/user/user.store';
import { PlayDemoBottomNavBtn } from './play-demo-bottom-nav.models';
import { PLAY_BTN_CONFIG } from './play-demo-bottom-nav.config';
import { PrefixLangs } from '../core-services/core.models';
import { Jurisdication } from '../core-services/visitor/visitor.model';
import { VisitorStore } from '../core-services/visitor/visitor.store';

export const PLAY_DEMO_BOTTOM_NAV_SELECTOR = 'whg-play-demo-bottom-nav';
@Component({
    selector: PLAY_DEMO_BOTTOM_NAV_SELECTOR,
    templateUrl: './play-demo-bottom-nav.component.html',
    styleUrls: ['./play-demo-bottom-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayDemoBottomNavComponent extends BaseComponent implements OnInit {
    @HostBinding('attr.role') role = 'navigation';
    @Input() gameLaunchCode: string;
    readonly playIcon: IconDefinition = faPlay;

    playBtn: PlayDemoBottomNavBtn = PLAY_BTN_CONFIG;
    demoBtn: PlayDemoBottomNavBtn;

    isLoggedIn: boolean = false;
    demoAvailable: boolean = false;
    jurisdications = Jurisdication;

    private gameDetails$: Observable<Game>;
    private sessionId: string;

    get langPrefix(): string {
        return this.coreService.getLangPrefix(this.jurisdiction, PrefixLangs.PlayDemoBottom);
    }

    constructor(
        private gameStore: GamesStore,
        private userStore: UserStore,
        private cdr: ChangeDetectorRef,
        private visitorStore: VisitorStore
    ) {
        super()
    }

    ngOnInit(): void {
        /*
        *   Since page is refreshing due to legacy, we need to re-get userDetails to put in our state
        */
        this.visitorStore.jurisdication$.pipe(takeUntil(this.destroy$)).subscribe(jurisdiction => {
            this.jurisdiction = jurisdiction;
            super.ngOnInit();
        });
        this.sessionId = this.coreService.getSessionIdFromCookie();
        this.userStore.addUserDetails(this.coreService.getUserDetails());

        /*
        *   Once we have userDetails, we can confirm user is logged in
        */
        this.userStore.userDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe(userDetails => {
            if (userDetails.userid) {
                this.isLoggedIn = true;
            }
        });

        /*
        *   Get details of game we are showing play/demo on
        */
        this.gameDetails$ = this.gameStore.getGameByLaunchCode(this.gameLaunchCode);

        this.gameDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe(game => {
            this.generatePlayBtn(game.launchcode);

            if (game.fun_supported > 0) {
                this.demoAvailable = true;
                this.generateDemoBtn(game.launchcode);
            }
        });
    }

    generatePlayBtn(launchCode: string): void {
        if (this.isLoggedIn) {
            this.playBtn = {
                ...this.playBtn,
                redirectUrl: `play?id=${launchCode}&mode=real`,
            }
        }
        this.cdr.markForCheck();
    }

    generateDemoBtn(launchCode: string): void {
        /*
        *   If game supports demo mode, show demo button
        */
        if (this.demoAvailable) {
            this.demoBtn = {
                redirectUrl: `play?id=${launchCode}&mode=fun`,
                styles: 'btn btn-secondary btn-lg'
            }
        }

        this.cdr.markForCheck();
    }

    setRecentGamesAndNavigate(): void {
    window.location.href = `${this.playBtn.redirectUrl}`;
  }

}
